export const resetData = {
  reset_title: 'Reset all data in this study',
  resret_text: 'Are you sure you want to reset all data in this study ? This action can\'t be undone.'
};
